import React, {forwardRef, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getDisplayValue} from "../../../helpers/getDisplayValue.helpers";
import {RequestFields} from "../../../constants/constants";
import Select from 'react-select';
import './editebleFields.scss'

const EditableField = forwardRef(({
                                      comment,
                                      label,
                                      value,
                                      oneAppId,
                                      isEditing,
                                      inputType = 'text',
                                      fieldConfig = { decimalPlaces: 0 },
                                      inputRef,
                                      onValueChange,
                                      fieldType = "text",
                                      options = [],
                                  }, ref) => {
    const [editedValue, setEditedValue] = useState(value);
    const [isCommentVisible, setIsCommentVisible] = useState(true);

    const handleCheckboxChange = (e) => {
        const newValue = e.target.checked;
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    useEffect(() => {
        setEditedValue(value);
    }, [value, isEditing]);

    const formatNumberValue = (val, decimalPlaces = 0) => {
        if (val === '' || val === null || val === undefined) return '';
        const num = typeof val === 'string' ? parseFloat(val) : val;
        if (isNaN(num)) return val;

        return num.toFixed(decimalPlaces);
    };

    const getDisplayValueForField = () => {
        if (inputType === 'number') {
            return formatNumberValue(value, fieldConfig.decimalPlaces);
        }
        return getDisplayValue(label, value, handleCheckboxChange);
    };

    const handleChange = (e) => {
        let newValue = e.target.value;

        if (inputType === 'number') {
            newValue = newValue.replace(/[^\d.,]/g, '');
            newValue = newValue.replace(',', '.');

            const parts = newValue.split('.');
            if (parts.length > 1 && parts[1].length > fieldConfig.decimalPlaces) {
                parts[1] = parts[1].slice(0, fieldConfig.decimalPlaces);
                newValue = parts.join('.');
            }

            const dotCount = (newValue.match(/\./g) || []).length;
            if (dotCount > 1) {
                return;
            }
        }

        setEditedValue(newValue);
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const handleSelectChange = (selectedOption) => {
        const newValue = selectedOption ? selectedOption.value : '';
        setEditedValue(newValue);
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const toggleCommentVisibility = () => {
        setIsCommentVisible(!isCommentVisible);
    };

    const displayValue = getDisplayValueForField();

    const selectedOption = options.find(opt => opt.value === editedValue) || null;

    if (isEditing) {
        if (fieldType === "select") {
            return (
                <div className="value">
                    <Select
                        ref={inputRef}
                        options={options}
                        value={selectedOption}
                        onChange={handleSelectChange}
                        className="editableField-select"
                        placeholder="Выберите значение..."
                    />
                </div>
            );
        }

        return (
            <div className="value">
                <input
                    ref={inputRef}
                    type="text"
                    inputMode={inputType === 'number' ? 'decimal' : 'text'}
                    value={editedValue || ''}
                    onChange={handleChange}
                    className="input"
                />
            </div>
        );
    }

    if (label === RequestFields.personalNumber) {
        return (
            <div className="value">
                {oneAppId ? (
                    <Link className="request-link" to={`/client/${oneAppId}`}>
                        <span>{displayValue}</span>
                    </Link>
                ) : (
                    <span>{displayValue}</span>
                )}
            </div>
        );
    }

    return (
        <div className="value">
            <div>{displayValue}</div>
            {comment && (
                <>
                    <button
                        onClick={toggleCommentVisibility}
                        className="comment-toggle"
                        type='button'
                    >
                        {isCommentVisible ? 'Скрыть комментарий' : 'Показать комментарий'}
                    </button>
                    {isCommentVisible && (
                        <div className='details-comment'>Комментарий: {comment}</div>
                    )}
                </>
            )}
        </div>
    );
});

export default EditableField;